import React from 'react';

// Sitecore `isExperienceEditorActive()` proxy;
// (and emulating this mode outside of Sitecore)
const ExperienceEditorContext = React.createContext(false);

/**
 * Hook alternative to use the Experience Editor.
 */
/**
 * Custom hook to access ExperienceEditorContext with fallback.
 * Returns the context value if available, otherwise returns false.
 *
 * @returns {boolean} Whether the Experience Editor is active.
 */
export const useExperienceEditorContext = () => {
	const context = React.useContext(ExperienceEditorContext);

	if (context === undefined || context === null) {
		return false;
	}

	return context;
};

/**
 * HOC for the React Context 'ExperienceEditorContext'; injects the
 * 'isExperienceEditorActive' prop into the provided <Component />.
 */
export const withExperienceEditorContext =
	<P extends object>(
		Component: React.ComponentType<P>,
	): React.FC<
		P & {
			isExperienceEditorActive: boolean;
		}
	> =>
	(props) =>
		(
			// eslint-disable-next-line react/display-name
			<ExperienceEditorContext.Consumer>
				{(isExperienceEditorActive) => (
					<Component {...(props as P)} {...{ isExperienceEditorActive }} />
				)}
			</ExperienceEditorContext.Consumer>
		);

export default ExperienceEditorContext;
